<template>
  <div class="dashboard-layout">
    <!-- Header Section -->
    <!-- <div class="dashboard-header mb-4">
      <div class="row align-items-center">
        <div class="col-12">
          <h1 class="dashboard-title mb-2">Dashboard</h1>
          <p class="dashboard-subtitle text-muted">Welcome back! Here's what's happening with your campaigns.</p>
        </div>
      </div>
    </div> -->

    <!-- Bento Grid Container -->
    <div class="bento-grid">
      <!-- Top Left - Small Card -->
      <div class="bento-card bento-card--small-top">
        <div class="bento-card__content">
          <!-- Add your content here -->
        </div>
      </div>

      <!-- Top Left - Medium Card -->
      <div class="bento-card bento-card--medium-left">
        <div class="bento-card__content">
          <!-- Add your content here -->
        </div>
      </div>

      <!-- Top Center - Large Card -->
      <div class="bento-card bento-card--large-center">
        <div class="bento-card__content">
          <!-- Add your content here -->
        </div>
      </div>

      <!-- Top Right - Tall Card -->
      <div class="bento-card bento-card--tall-right">
        <div class="bento-card__content">
          <!-- Add your content here -->
        </div>
      </div>

      <!-- Bottom Right - Small Card -->
      <div class="bento-card bento-card--small-bottom-right">
        <div class="bento-card__content">
          <!-- Add your content here -->
        </div>
      </div>

      <!-- Bottom - Wide Card -->
      <div class="bento-card bento-card--wide-bottom">
        <div class="bento-card__content">
          <!-- Add your content here -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DashboardLayout',
  data() {
    return {
      // Component data can be added here
    };
  },
  mounted() {
    // Component initialization
  }
});
</script>

<style scoped>
.dashboard-layout {
  background-color: #F5F7FB;
  min-height: 100vh;
}

.dashboard-header {
  margin-bottom: 2rem;
}

.dashboard-title {
  font-size: 2rem;
  font-weight: 700;
  color: #25262C;
  margin: 0;
}

.dashboard-subtitle {
  font-size: 1rem;
  color: #535865;
  margin: 0;
}

/* Bento Grid Layout */
.bento-grid {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: auto auto auto;
  gap: 1.5rem;
  width: 100%;
}

/* Card Base Styles */
.bento-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #F1F2F2;
  overflow: hidden;
  transition: all 0.3s ease;
  min-height: 120px;
}

.bento-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.bento-card__content {
  padding: 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Card Positioning - Matching the image layout */
.bento-card--small-top {
  grid-column: 1;
  grid-row: 1;
  height: 120px;
}

.bento-card--medium-left {
  grid-column: 1;
  grid-row: 2;
  height: 200px;
}

.bento-card--large-center {
  grid-column: 2;
  grid-row: 1 / 3;
  height: 340px;
}

.bento-card--tall-right {
  grid-column: 3;
  grid-row: 1 / 3;
  height: 340px;
}

.bento-card--small-bottom-right {
  grid-column: 3;
  grid-row: 3;
  height: 120px;
}

.bento-card--wide-bottom {
  grid-column: 1 / 3;
  grid-row: 3;
  height: 120px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-layout {
    padding: 1rem;
  }
  
  .bento-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 1rem;
  }
  
  .bento-card--small-top,
  .bento-card--medium-left,
  .bento-card--large-center,
  .bento-card--tall-right,
  .bento-card--small-bottom-right,
  .bento-card--wide-bottom {
    grid-column: 1;
    grid-row: auto;
    height: auto;
    min-height: 120px;
  }
}

@media (max-width: 480px) {
  .bento-card__content {
    padding: 1rem;
  }
}
</style>
